export * from "./Clock";
//# sourceMappingURL=index.js.map